import gql from "graphql-tag";

import { Fragment, MadSupervisor } from "../types";

import {
  UserSummaryFragment,
  USER_SUMMARY_FRAGMENT,
} from "./User";

export const MAD_SUPERVISOR_FRAGMENT = gql`
  fragment MadSupervisorFragment on MadSupervisor {
    id
    emailNotificationsEnabled
    user {
      ...UserSummaryFragment
    }
  }

  ${USER_SUMMARY_FRAGMENT}
`;

export type MadSupervisorFragment = Fragment<
  MadSupervisor,
  Pick<MadSupervisor, "id" | "emailNotificationsEnabled">
   & {
     user: UserSummaryFragment
   }
>;
